// REVELATE Hybrid Dictionary v1

import words from "./revelate_hybrid_dictionary.json";

export const REVELATE_DICTIONARY_WORDS = words;
export const REVELATE_DICTIONARY = new Set(words);